import Vue from 'vue'
import proxy from '../helpers/httpProxy'

Vue.use(proxy)
